import * as React from "react"
import {Box} from "@mui/material";
import {formatDate} from "@ui-seeker/utils";


const _formatDate = d => formatDate(d, { isString: true })

export default function PriceEvolutionTabsSubtitle({ numTabs, isSplitBySku, isPercentage, startDate, endDate, prevStartDate, prevEndDate }) {
    return <Box display="flex" flexDirection="column">
        <Box>
            Average {isPercentage ? 'Discount' : 'Price'} in selected period vs. previous, with a total of {numTabs} {isSplitBySku ? 'SKUs ' : 'Retailers '}
        </Box>
        <Box display="flex" gap={1}>
            <Box component="strong">
                {_formatDate(startDate)} - {_formatDate(endDate)}
            </Box>
            <Box component="strong">
                vs
            </Box>
            <Box component="em">
                {_formatDate(prevStartDate)} - {_formatDate(prevEndDate)}
            </Box>
        </Box>
    </Box>
}